<div [formGroup]="formGroup">
    <div class="flex gap-12 flex-column" [formGroupName]="controlName">
        @if (autocomplete) {
            <p-multiSelect
                #multiselect
                [options]="filteredEnumInput"
                appendTo="body"
                [filter]="true"
                [ngModelOptions]="{ standalone: true }"
                [(ngModel)]="selectedOptions"
                styleClass="min-w-min w-full height-40 text-md "
                (onPanelShow)="onDropdownOpen(multiselect)"
                (onPanelHide)="onDropdownClose(multiselect)"
                dropdownIcon="pi pi-chevron-down"
                display="chip"
                class="filter-chips"
                [pTooltip]="selectedOptions.length ? tooltipContent : ''"
                tooltipPosition="bottom"
                (onChange)="onMultiSelectChange()"
                placeholder="Select"
            >
                <ng-template pTemplate="filter">
                    <span class="p-input-icon-left w-full h-full flex justify-content-end">
                        <input
                            #searchInput
                            type="text"
                            pInputText
                            class="p-inputtext-sm w-full"
                            placeholder="{{ 'default-admin-filter-serach' | translate: 'Search option' }} "
                            (input)="search(searchInput.value)"
                        />
                        <i class="pi pi-search"></i>
                        @if (searchInput.value) {
                            <i class="pi pi-times mx-2 cursor-pointer" (click)="searchInput.value = ''; search('')"></i>
                        }
                    </span>
                </ng-template>
                <ng-template let-value pTemplate="selectedItems">
                    @for (option of selectedOptions | slice: 0 : 2; track option; let i = $index) {
                        <p-chip
                            [label]="option"
                            styleClass="text-sm py-0 radius-3xl mr-2"
                            class="filter-chips"
                            [removable]="true"
                            (onRemove)="onRemove(option, i)"
                        >
                            <ng-template pTemplate="removetokenicon">
                                <div class="flex filter-chips">
                                    <svg class="w-1rem h-1rem" viewBox="0 0 20 20">
                                        <rect width="20" height="20" rx="10" fill="#EAF0FB" />
                                        <path
                                            d="M6 14L14 6.00085"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                        <path
                                            d="M14 13.9991L6 6"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                </div>
                            </ng-template>
                        </p-chip>
                    }
                    @if (selectedOptions.length > 2) {
                        <span class="p-multiselect-token">+{{ selectedOptions.length - 2 }}</span>
                    }
                    @if (selectedOptions.length <= 0) {
                        <span class="text-sm font-normal text-color-secondary">Select</span>
                    }
                </ng-template>
                <ng-template pTemplate="empty">
                    <img src="assets/icons/no-result-found.svg" alt="" />
                    {{ 'default-cm-noResultFound' | translate: 'No results found' }}
                </ng-template>
            </p-multiSelect>
            <ng-template #tooltipContent>
                <span>{{ selectedOptions | join }}</span>
            </ng-template>
        } @else {
            @for (option of enumInput; track $index) {
                <div class="flex justify-content-between gap-2">
                    <span>{{ option }}</span>
                    <p-checkbox [formControlName]="option" [value]="option" [binary]="true"></p-checkbox>
                </div>
            }
        }
    </div>
</div>
